import { Box, Stack, Typography } from "@mui/material";
import { StackerHeat } from "../models/StackerBundle";

const HeatSegment = ({
	label,
	heatName,
	gradeName,
	active,
}: {
	label: string;
	heatName: string | null | undefined;
	gradeName: string | null | undefined;
	active?: boolean;
}) => (
	<Box
		sx={{
			flex: 1,
			minWidth: 0,
			px: 1.5,
			py: 0.75,
			bgcolor: active ? "primary.50" : "grey.100",
			borderRadius: 1,
		}}
	>
		<Typography
			variant="caption"
			sx={{
				display: "block",
				whiteSpace: "nowrap",
				textTransform: "uppercase",
				letterSpacing: 0.5,
				fontSize: "0.55rem",
				lineHeight: 1.2,
				fontWeight: 600,
				color: active ? "primary.main" : "text.secondary",
			}}
		>
			{label} Heat
		</Typography>

		<Box
			sx={{ display: "flex", alignItems: "baseline", gap: 0.75, height: 19 }}
		>
			<Typography
				sx={{
					fontWeight: 600,
					fontSize: "0.95rem",
					lineHeight: 1.2,
					color: active ? "text.primary" : "text.secondary",
				}}
			>
				{heatName || "—"}
			</Typography>

			{gradeName && (
				<Typography
					sx={{
						fontSize: "0.65rem",
						fontWeight: 500,
						color: active ? "primary.main" : "text.secondary",
					}}
				>
					{gradeName}
				</Typography>
			)}
		</Box>
	</Box>
);

export const StackerHeatPanel = ({ heat }: { heat: StackerHeat | null }) => (
	<Box
		sx={{
			display: "inline-flex",
			alignItems: "stretch",
			border: 1,
			borderColor: "divider",
			borderRadius: 1,
			overflow: "hidden",
			bgcolor: "background.paper",
		}}
	>
		<HeatSegment
			label="Previous"
			heatName={heat?.PreviousHeatName}
			gradeName={heat?.PreviousGradeName}
		/>
		<Box sx={{ width: "1px", bgcolor: "divider" }} />
		<HeatSegment
			label="Current"
			heatName={heat?.CurrentHeatName}
			gradeName={heat?.CurrentGradeName}
			active
		/>
	</Box>
);
